"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UrlParam = exports.Uid = void 0;
var _utils = require("@zz-biz/utils");
var Uid = _utils.Cookie.get('uid') || _utils.Query.get('zzUid') || 0;
exports.Uid = Uid;
var UrlParam = {
  channel: decodeURIComponent(_utils.Query.get('channel') || 0),
  trigger: decodeURIComponent(_utils.Query.get('trigger') || 0)
};
exports.UrlParam = UrlParam;